import React, { useEffect } from "react";
import DeleteDialog from "../../../components/DeleteDialog";
/* Project References */
import Pagination              from "../../../components/Pagination";
import SkeletonTableLoad       from "../../../components/SkeletonTableLoad";
import { CrossCountryEntry }   from "../../../models/Admin/CrossCountryEntry";
import { PageableCollection }  from "../../../models/PageableCollection";
import msalRestClient          from "../../../services/clients/MsalRestClient";
import PostCrossCountry        from "./PostCrossCountry";

const CrossCountryMatrix = () => {

    let emptyMatrix: PageableCollection<CrossCountryEntry> = {
        totalPages : 0,
        count      : 0,
        next       : "",
        previous   : "",
        results    : []
    }

    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [matrix, setMatrix] = React.useState<PageableCollection<CrossCountryEntry>>(emptyMatrix);

    /**
     * Function handles deletion of single entries.
     * @param index Index of entry that needs to be deleted.
     */
    async function handleDelete(index?: number) {

        /* Check if index is passed on */
        if (index && index > -1)
        {
            let entity = matrix.results.at(index);
            if (entity) {

                /* Delete from Cross Table */
                msalRestClient.delete("/api/crosscountries/" + entity.id)
                    .then(response => {
                        if (response.status === 200) {
                            /* Set fetched Matrix after the selected entry has been deleted */
                            fetchCollection(0);
                        }
                    })
                    .catch(error => {
                        // Proper error handling goes here ...
                    })
            }
        }
    }

    /**
     * Function handles creation of new entry.
     * @param newEntry: Newly created entry.
     */
    async function onSuccessfullyCreated(newEntry: CrossCountryEntry)
    {
        fetchCollection(0);
    }

    /**
     * Method fetches a collection of all saved Country2Country entries.
     * @param page
     */
    async function fetchCollection(page: number)
    {
        setIsLoading(true);

        /* Fetch data from backend service */
        msalRestClient.get<PageableCollection<CrossCountryEntry>>("/api/crosscountries?page=" + page)
            .then(response => {
                if (response.status === 200) {
                    /* Set fetched Matrix to current state */
                    setMatrix(response.data);
                }
                else if (response.status === 204) {
                    /* No Matrix entries found, set state to empty matrix */
                    setMatrix(emptyMatrix);
                }
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => setIsLoading(false));
    }

    /**
     * Method handles change of pagination component.
     * @param page New page index.
     */
    async function onPaginationChange(page: number) {

        fetchCollection(page);
    }

    useEffect(() => {
        fetchCollection(1);
    }, [])

    return (
        <main className="container">

            <div className="row">

                <div className="col-12 col-md-6">
                    <PostCrossCountry onSuccess={onSuccessfullyCreated} key={"cCDialog"} />
                </div>

                <div className="col-12 col-md-6">
                    <Pagination onPageChange={onPaginationChange} next={matrix.next} previous={matrix.previous} count={matrix.count} totalPages={matrix.totalPages} />
                </div>

                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            {
                                isLoading ? <SkeletonTableLoad columnCount={5} rowCount={15} striped={false} />
                                    :
                                    <table className="table table-stripped">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Start Country</th>
                                                <th>Destination Country</th>
                                                <th>Refund Rate</th>
                                                <th>
                                                    { /* Empty for controls */ }
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                matrix.results.map((value, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{value.id}</td>
                                                            <td>{value.sourceCountry}</td>
                                                            <td>{value.targetCountry}</td>
                                                            <td>&euro; {Math.round(value.refundRate)}</td>
                                                            <td>
                                                                <DeleteDialog index={index} title={"Please confirm ..."} description={"Do you really want to delete the record?"} btnClass={"btn btn-danger"} btnIcon={"bi bi-trash"} onConfirm={handleDelete} key={"btnDelete" + index} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </main>
    )
}
export default CrossCountryMatrix;